class PushCartRecommendations extends window.BAO.CustomElement() {
  constructor () {
    super()

    // Stop if it's powered by a collection
    if (this.dataset.poweredBy === 'collections') return

    // Stop if there is no product
    if (this.dataset.url.includes('product_id=&')) return

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('push-cart-recommendations')
        if (recommendations && recommendations.innerHTML.trim().length) {
          // Only extract the actual recommendations content, not the entire section
          const recommendedProducts = recommendations.querySelector('.psh-RecommendedProducts')
          if (recommendedProducts) {
            this.innerHTML = recommendedProducts.outerHTML
          } else {
            this.innerHTML = recommendations.innerHTML
          }

          document.dispatchEvent(new CustomEvent('reccsAdded'))
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  get baseUrl () {
    return this.dataset.baseUrl
  }

  get limit () {
    return this.dataset.limit
  }

  get productId () {
    return this.dataset.productId
  }

  get intent () {
    return this.dataset.intent
  }

  get sectionId () {
    return this.dataset.sectionId
  }
}

if (!customElements.get('push-cart-recommendations')) {
  customElements.define('push-cart-recommendations', PushCartRecommendations)
}
